import { useState } from 'react';

import { WhiteboardData } from './types';

const defaultData = {
  shapes: {},
  assets: {},
  bindings: {},
  sections: {},
  state: [],
};

export function useLocalStorage() {
  const [data, setData] = useState<WhiteboardData>(() => {
    const localStorageData = localStorage.getItem('whiteboard-data');
    if (localStorageData) {
      return JSON.parse(localStorageData);
    } else {
      return {};
    }
  });

  const saveDataToLocalStorage = (id: string, newData: any) => {
    if (newData != null) {
      const newWhiteboardData = { ...data, [id]: newData };
      localStorage.setItem('whiteboard-data', JSON.stringify(newWhiteboardData));
      setData(newWhiteboardData);
    }
  };

  const getDataFromLocalStorage = (id: string) => {
    const localStorageData = localStorage.getItem('whiteboard-data');
    if (localStorageData) {
      const whiteboardData = JSON.parse(localStorageData) as WhiteboardData;
      return whiteboardData[id] || defaultData;
    }
    return defaultData;
  };

  const clearDataForId = (id: string) => {
    const localStorageData = localStorage.getItem('whiteboard-data');
    if (localStorageData) {
      const whiteboardData = JSON.parse(localStorageData) as WhiteboardData;
      if (whiteboardData[id]) {
        delete whiteboardData[id];
        localStorage.setItem('whiteboard-data', JSON.stringify(whiteboardData));
        setData(whiteboardData);
      }
    }
  };

  const clearAllData = () => {
    localStorage.removeItem('whiteboard-data');
    setData({});
  };

  return { data, saveDataToLocalStorage, getDataFromLocalStorage, clearDataForId, clearAllData };
}
